import { connectFela } from '../../dependencies';
import RecurringExports from './RecurringExports';
import * as styles from './RecurringExports.styles';

export default connectFela(styles)(RecurringExports);
